import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Loading from "../pages/Loading";
import { useSession } from "../session/Context";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import { AnyMxRecord } from "dns";

let serverUrl = window.location.origin;

const { palette } = createTheme();
const theme = createTheme({
  palette: {
    secondary: {
      main: "#FF297F",
    },
    primary: {
      main: "#231f20",
    },
  },
  typography: {
    fontFamily: "Saira",
  },
});

interface ManagerData {
  notifData: any;
}

const Notifications = (props: ManagerData) => {
  // notification get data
  const { notifications } = useSession();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [tabType, setTabType] = useState("pending");

  const handleChangeTab = (event: any) => {
    let tabType = "pending";

    if (event === 1) {
      tabType = "history";
      setTabType("history");
    }
  };

  useEffect(() => {
    handleChangeTab(0);
  }, []);

  const [value, setValue] = React.useState("1");

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const tabPanelStyle = {
    padding: "0px",
  };

  // History
  const [history, setHistory] = React.useState<any[]>([]);

  React.useEffect(() => {
    getNotifications();
  }, []);

  const getNotifications = () => {
    fetch("/api/v1/user?type=notification_history")
      .then((resp) => resp.json())
      .then((notifications) => {
        if (!notifications.success) {
          throw notifications.reason;
        }
        setHistory(notifications.response);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Notifications</h2>
        </div>
      </div>

      <div className="col-content">
        <div className="notifications-container">
          <div className="messages  no-mobile-pro">
            <p className="light">Notification center</p>
            <h2>Manage notifications</h2>
          </div>
          <ThemeProvider theme={theme}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <Box>
                  <TabList
                    value={value}
                    onChange={handleChange}
                    sx={{
                      "& .css-9zg40m-MuiButtonBase-root-MuiTab-root": {
                        padding: 0,
                        marginRight: "20px",
                      },
                      "& .MuiTab-root.Mui-selected": {
                        color: "#231f20",
                      },
                      "& .MuiTab-textColorSecondary": {
                        color: "#CECECE",
                      },
                    }}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                  >
                    <Tab
                      label={"New notifications / " + notifications.length}
                      value="1"
                    />
                    <Tab label={"History / " + history.length} value="2" />
                  </TabList>
                </Box>

                <TabPanel sx={tabPanelStyle} value="1">
                  <Notifi getNotifications={getNotifications} />
                </TabPanel>
                <TabPanel sx={tabPanelStyle} value="2">
                  <NotifiHistory history={history} />
                </TabPanel>
              </TabContext>
            </Box>
          </ThemeProvider>
        </div>
      </div>
    </>
  );
};

export default Notifications;

const MyCardHeader = styled(CardHeader)({
  display: "flex",
  justifyContent: "space-between",
  //alignItems: 'center',
  flexWrap: "wrap",
  "& .MuiCardHeader-content": {
    display: "flex",
  },
  "& .MuiCardHeader-title": {
    flexGrow: 1,
    textAlign: "left",
    fontSize: "17px",
    fontWeight: "500",
    span: {
      width: "50%",
    },
  },
  "& .MuiCardHeader-subheader": {
    textAlign: "right",
    paddingRight: "10px",
    whiteSpace: "nowrap",
  },
  margin: "0",
  padding: "8px 8px 4px",
});

export interface NotifiProps {
  getNotifications: () => void;
}

export function Notifi(props: NotifiProps) {
  const { notifications } = useSession();

  const [expanded, setExpanded] = useState(notifications.map(() => false));

  const handleExpandClick = (index: any) =>
    function () {
      const newExpanded = expanded.map((el, i) => {
        if (el && i == index) {
          return el;
        }
        return false;
      });

      newExpanded[index] = !newExpanded[index];
      setExpanded(newExpanded);
    };

  const renderData = () => {
    if (notifications.length !== expanded.length) {
      setExpanded(notifications.map(() => false));
    }

    if (notifications.length !== 0) {
      return notifications.map((el, index) => {
        // console.log(el);
        let date = "";
        if (el.data.hasOwnProperty("created_at")) {
          date = el.data.created_at.split("T")[0];
        }
        return (
          <div className="cardNotify clickable" key={el.id}>
            <Card
              onClick={handleExpandClick(index)}
              sx={{
                borderRadius: "0px",
                boxShadow: "none",
                marginBottom: "2px",
                "& .MuiCardHeader-root": {
                  backgroundColor: "rgba(0,0,0, 0.06)",
                  fontSize: "17px",
                },
                "& .MuiCollapse-root": {
                  backgroundColor: "rgba(0,0,0, 0.03)",
                  borderTop: "2px solid white",
                },
                "& .MuiCardContent-root": {
                  padding: "0px",
                },
                "& .MuiCardContent-root:last-child": {
                  padding: "0px",
                },
              }}
            >
              <MyCardHeader
                /* action={
                    <ExpandMore
                      expand={expanded[index]}
                      onClick={handleExpandClick(index)}
                      aria-expanded={expanded[index]}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  } */

                title={el.data.title}
                subheader={getNiceDate(el.data.created_at)}
              />

              <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                <CardContent>
                  <div className="notifications-details-container">
                    <p className="notifications-details-text">{el.data.desc}</p>
                    {Object.keys(el.data.actions).length > 0 ? (
                      <CardActions>
                        {Object.keys(el.data.actions).map((name) => {
                          return (
                            <Button
                              key={el.id + "_" + name}
                              size="small"
                              id={"accept_" + el.id}
                              onClick={() => {
                                el.do(el.data.actions[name])
                                  .then((val) => {
                                    // console.log(val);
                                    if (
                                      val !== null &&
                                      val.hasOwnProperty("redirect")
                                    ) {
                                      window.location.href =
                                        serverUrl + val.redirect;
                                    } else {
                                      props.getNotifications();
                                      toast.info("Notification action saved!");
                                    }
                                  })
                                  .catch((e) => {
                                    toast.error(
                                      "Unable to save action. \n" + e
                                    );
                                  });
                              }}
                              sx={{ backgroundColor: "white" }}
                            >
                              {name}
                            </Button>
                          );
                        })}
                      </CardActions>
                    ) : (
                      <CardActions>
                        <Button
                          key={el.id}
                          size="small"
                          id={"accept_" + el.id}
                          onClick={() => {
                            el.do("")
                              .then((val) => {
                                if (val !== "done") {
                                  throw new Error(val);
                                } else {
                                  toast.info("Notification action saved!");
                                  props.getNotifications();
                                }
                              })
                              .catch((e) => {
                                toast.error("Unable to save action. \n" + e);
                                console.log("Unable to save action. \n" + e);
                              });
                          }}
                          sx={{ backgroundColor: "white" }}
                        >
                          Mark as read
                        </Button>
                      </CardActions>
                    )}
                  </div>
                </CardContent>
              </Collapse>
            </Card>
          </div>
        );
      });
    } else {
      return (
        <div className="messages">
          <p className="no-data">No new notifications</p>
        </div>
      );
    }
  };

  return (
    <>
      <div>{renderData()}</div>
    </>
  );
}

//------------------------------------------------------------------------------//

function getNiceDate(date: any): string {
  let d = new Date(date);
  return d.toDateString() + " " + d.toLocaleTimeString();
}

export function NotifiHistory(props: any) {
  let history = props.history;

  const [expanded, setExpanded] = React.useState(history.map(() => false));

  const handleExpandClick = (index: any) =>
    function () {
      const newExpanded = expanded.map((el: any, i: any) => {
        if (el && i == index) {
          return el;
        }
        return false;
      });

      newExpanded[index] = !expanded[index];
      setExpanded(newExpanded);
    };

  const renderData = () => {
    if (history.length !== expanded.length) {
      setExpanded(history.map(() => false));
    }

    if (history.length !== 0) {
      return history.map((el: any, index: any) => {
        return (
          <div className="cardNotify clickable" key={el.id}>
            <Card
              onClick={handleExpandClick(index)}
              sx={{
                borderRadius: "0px",
                boxShadow: "none",
                marginBottom: "2px",
                "& .MuiCardHeader-root": {
                  backgroundColor: "rgba(0,0,0, 0.06)",
                  fontSize: "17px",
                },
                "& .MuiCollapse-root": {
                  backgroundColor: "rgba(0,0,0, 0.03)",
                  borderTop: "2px solid white",
                },
                "& .MuiCardContent-root": {
                  padding: "4px",
                },
                "& .MuiCardContent-root:last-child": {
                  padding: "0px",
                },
              }}
            >
              <MyCardHeader
                /*
                  action={
                    <ExpandMore
                      expand={expanded[index]}
                      aria-expanded={expanded[index]}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  }*/
                title={el.title}
                subheader={getNiceDate(el.created_at)}
              />

              <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                <CardContent>
                  <div className="notifications-details-container">
                    <p className="notifications-details-text">{el.desc}</p>
                    {el.action_taken && (
                      <p className="notifications-details-action">
                        {/* Action: {el.action_taken} */}
                        {el.action_by && (
                          <>
                            {/*  <br></br> */}
                            By: {el.action_by.email} on{" "}
                            {getNiceDate(el.action_taken_at)}
                          </>
                        )}
                      </p>
                    )}
                  </div>
                </CardContent>
              </Collapse>
            </Card>
          </div>
        );
      });
    } else {
      return (
        <div className="messages">
          <p className="no-data">No data available yet</p>
        </div>
      );
    }
  };

  return (
    <>
      <div>{renderData()}</div>
    </>
  );
}
